import ImageUpload from 'components/CustomUpload/ImageUpload'
import React, { useState, useContext, useEffect } from 'react'
import { Col, Row, Alert } from 'reactstrap'
import { ErrorMessage, useFormContext } from 'react-hook-form'
import SubmitContext from 'context/submit/submitContext'

export const initialData = [
  {
    fkProduct: 0,
    pkProductIMG: 0,
    ImageName: '',
    ImageType: '',
    ProdImg: '',
  },
  {
    fkProduct: 0,
    pkProductIMG: 0,
    ImageName: '',
    ImageType: '',
    ProdImg: '',
  },
  {
    fkProduct: 0,
    pkProductIMG: 0,
    ImageName: '',
    ImageType: '',
    ProdImg: '',
  },
  {
    fkProduct: 0,
    pkProductIMG: 0,
    ImageName: '',
    ImageType: '',
    ProdImg: '',
  },
]
const ImagesUpload = () => {
  const methods = useFormContext()

  const submitContext = useContext(SubmitContext)
  const { current, updating, setCurrent, loadProductImages } = submitContext

  const [currentImages, setCurrentImages] = useState(initialData)

  useEffect(() => {
    if (current?.images) {
      setCurrentImages(current.images)
    } else {
      setCurrentImages(initialData)
      if (updating) {
        loadProductImages(current.pkProduct)
      }
    }
    // eslint-disable-next-line
  }, [current])

  const updateImageInfo = (imageIndex, imageData) => {
    let newImages = [...currentImages]
    newImages[imageIndex] = {
      ...newImages[imageIndex],
      ImageName: imageData.ImageName,
      ImageType: imageData.ImageType,
      ProdImg: imageData.ProdImg,
    }
    // Set the global 'current' object with new images data
    setCurrent({ ...current, images: newImages })
  }

  return (
    <>
      <Row>
        <Col>
          <ul>
            <li>
              <strong>
                Clear, upright images showing the front label, back label, UPC,
                nutrition label, and ingredients list
              </strong>
            </li>
            <li>
              <strong>JPG or single page PDF</strong>
            </li>
            <li>
              <strong>4 MB max size</strong>
            </li>
          </ul>
        </Col>
      </Row>
      <Row>
        {currentImages.map((imageData, index) => {
          return (
            <Col xs={3} className="text-center" key={index}>
              <ImageUpload
                index={index}
                imageInfo={imageData}
                updateImageInfo={updateImageInfo}
                isSubmitter={true}
                isDisabled={false}
              />
            </Col>
          )
        })}
      </Row>
      <Row className={'justify-content-center'}>
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="ImagesUpload"
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Row>
    </>
  )
}

export default ImagesUpload
